import { SurveyGroups } from '../model/survey_groups';
import { SurveyGroupsList } from '../model/survey_groups-list';
import * as _ from 'lodash-es';
export class SurveyGroupsBuilder {
    static buildSurveyGroupsList(data) {
        const surveyGroupsList = new SurveyGroupsList();
        surveyGroupsList.page = data.page;
        surveyGroupsList.pagination = data.pagination;
        surveyGroupsList.total = data.total;
        surveyGroupsList.total_pages = data.total_pages;
        surveyGroupsList.surveys_groups = _.map(data.surveys_groups, (surveys_groups) => {
            return this.buildSurveyGroups(surveys_groups);
        });
        return surveyGroupsList;
    }
    static buildSurveyGroups(data) {
        let survey_groups = new SurveyGroups();
        survey_groups.id = data.id;
        survey_groups.name = data.name;
        survey_groups.email_subject_es = data.email_subject_es;
        survey_groups.email_subject_ca = data.email_subject_ca;
        survey_groups.email_subject_en = data.email_subject_en;
        survey_groups.email_subject_fr = data.email_subject_fr;
        survey_groups.email_header_es = data.email_header_es;
        survey_groups.email_header_ca = data.email_header_ca;
        survey_groups.email_header_en = data.email_header_en;
        survey_groups.email_header_fr = data.email_header_fr;
        survey_groups.email_body_es = data.email_body_es;
        survey_groups.email_body_ca = data.email_body_ca;
        survey_groups.email_body_en = data.email_body_en;
        survey_groups.email_body_fr = data.email_body_fr;
        survey_groups.email_button_copy_es = data.email_button_copy_es;
        survey_groups.email_button_copy_ca = data.email_button_copy_ca;
        survey_groups.email_button_copy_en = data.email_button_copy_en;
        survey_groups.email_button_copy_fr = data.email_button_copy_fr;
        survey_groups.thanks_body_es = data.thanks_body_es;
        survey_groups.thanks_body_ca = data.thanks_body_ca;
        survey_groups.thanks_body_en = data.thanks_body_en;
        survey_groups.thanks_body_fr = data.thanks_body_fr;
        return survey_groups;
    }
}
//# sourceMappingURL=survey-groups-builder.js.map